/* Purpose: Clients can view and edit Financial Information
 * Props: onBlur (func)
 *          handleChangeTab (func)
 *          stopSave (boolean)
 *          saveBtnText (str)
 *          clickedSave (boolean)
 *          requFinancialInfo (list of map)
 *          handleClickSave (func)
 *          handleInfoChange (func)
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React, {useEffect} from 'react';
import {Form, Row, Alert, Container, Col} from 'react-bootstrap';
import SubmitButton from '../../Components/Button';
import { useNavigate } from 'react-router-dom';

const Financial = ({onBlur, handleChangeTab, stopSave, saveBtnText, clickedSave, requFinancialInfo, handleClickSave, handleInfoChange}) => {
    const navigateTo = useNavigate();

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    }, [])

    const handleNext  = () => {
        if (!clickedSave){
            alert("Your information has not been saved! Please save before leaving this page.")
        }else{
            navigateTo("/Portal/Loans")
        }
    }
      
    return(
        <> 
            <Container>
                <Form className='my-3'>
                    {requFinancialInfo.map((item, index) => (
                        <div className = 'my-1' key = {index}>
                            <Form.Group key = {index} type="text"> 
                                <Form.Label>{item.fieldName}: </Form.Label>
                                <Form.Control 
                                id={item.fieldName} 
                                value= {item.value} 
                                onChange={(event) => {handleInfoChange(index, event)}}
                                isInvalid = {"isValid" in item?!item.isValid:false}
                                onBlur = {() => onBlur(item, index)}
                                />
                                <Form.Control.Feedback type = "invalid">{item.invalidMsg}</Form.Control.Feedback>
                            </Form.Group>
                        </div>
                    ))}

                    {stopSave && (
                        <Row className="align-items-center mt-3">
                        <Alert className = "text-center w-80" variant = "danger" >Your changes have NOT been saved. One or more fields contain invalid data. Please fix your data and try saving again.</Alert>
                        </Row>
                    )}

                    <Row  xs = {2} sm={2} md = {3} className='g-4 m-2'>
                        <Col className='text-start' xs={{order: 2}} md = {{order: 1}}>
                            <SubmitButton text = "<< Back" width = "52" onClick = {() => handleChangeTab("Personal")}/>
                        </Col>
                        <Col className='text-center' xs = {{span: '12', order: 1}} sm ={{span: '12', order: 1}} md = {{order: 2}}>
                            <SubmitButton text = {saveBtnText} onClick = {handleClickSave} width = "90"/>
                        </Col>
                        <Col className='text-end' xs = {{order: 3}} md = {{order: 3}}>
                            <SubmitButton text = "Next >>" width = "52" onClick = {handleNext}/>
                        </Col>
                    </Row>

                </Form>
            </Container>  
        </>
        
    );
};

export default Financial;